<template>
  <nav>
    <ul>
      <li @click="navigate('badges')">Kwaliteit</li>
      <li @click="navigate('galery')">Projecten</li>
      <li @click="navigate('contact')">Contact</li>
    </ul>
    <div class="mobile">
      <img src="@/assets/img/menu.png" @click="menu = !menu"/>
      <div class="menu" v-if="menu">
        <ul>
          <li id="first" @click="navigate('badges')">Kwaliteit</li>
          <li @click="navigate('galery')">Projecten</li>
          <li @click="navigate('contact')">Contact</li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import Navigation from '@/navigation.js'
export default {
  name: 'AppNav',
  data () {
    return {
      menu: false,
    }
  },
  methods: {
    navigate (to) {
      //this.menu = false;
      Navigation.$emit(to);
    },
    handleScroll() {
      this.menu = false;
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>
<style lang="scss" scoped>
  @import '../assets/css/definitions';
  nav {
    ul {
      display: flex;
      flex-direction: row;
      width: 30%;
      list-style: none;
      margin-left: 40%;
      li {
        padding: 10px;
        margin-left: 15%;
        font-size: 30px;
        cursor: pointer;
      }
      li:hover {
        color: black;
      }
    }
    .mobile {
        visibility: hidden;
      }
    @media screen and (max-width: 1024px) {
      ul {
        visibility: hidden;
      }
      .mobile {
        visibility: visible;
        .menu {
          position: fixed;
          top: 185px;
          left: 0;
          z-index: 1;
          width: 100%;
          background: $color-bg;
          margin-left: 0;
          ul {
            display: flex;
            flex-direction: column;
            z-index: 2;
            visibility: visible;
            text-align: center;
            margin-left: 0;
            width: 100%;
            border-top: 1px solid black;
            border-bottom: 1px solid black;
            li {
              margin-left: 0;
              border: 1px solid black;
            }
          }
        }
        img {
          position: absolute;
          right: 0;
          top: 0;
          width: 100px;
        }
      }
    }
  }

</style>
